import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE
  ? `${process.env.REACT_APP_API_BASE.replace(/\/$/, '')}/api`
  : '/api';

const client = axios.create({ baseURL });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('aaarya_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      // token expired or invalid
      localStorage.removeItem('aaarya_token');
      localStorage.removeItem('aaarya_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default client;
